/**
 * Request header that lets the backend recognize a repeated order-creating request and
 * replay the stored outcome instead of creating a second order/charge.
 */
export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';

/**
 * Sets the `Idempotency-Key` header on a request config. Additive and non-mutating: when
 * `key` is falsy the original config is returned unchanged.
 */
export function withIdempotencyKey<T extends object>(config: T, key: string | undefined): T & { headers?: Record<string, string> } {
    if (!key) {
        return config;
    }

    return {
        ...config,
        headers: {
            ...(config as { headers?: Record<string, string> }).headers,
            [IDEMPOTENCY_KEY_HEADER]: key,
        },
    };
}
